import React from "react";
import Skeleton from "react-loading-skeleton-2";

import Table from "../Table";

const Dashboard = () => (
  <div>
    <div className="d-flex align-items-center gap-6 justify-content-between mb-6">
      <Skeleton height={22} width={124} />
      <Skeleton height={38} width={144} />
    </div>
    <div className="mb-6">
      <Skeleton height={288} />
    </div>

    <div>
      <Table>
        <thead>
          <tr>
            <Table.Th>
              <Skeleton height={12} width={124} />
            </Table.Th>
            <Table.Th>
              <Skeleton height={12} width={124} />
            </Table.Th>
            <Table.Th>
              <Skeleton height={12} width={124} />
            </Table.Th>
            <Table.Th>
              <Skeleton height={12} width={124} />
            </Table.Th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 5 }).map((_, key) => (
            <tr key={key}>
              <Table.Td className="gap-4">
                <Skeleton circle width={24} height={24} />
                <Skeleton width={144} height={14} />
              </Table.Td>
              <Table.Td>
                <Skeleton height={14} width={144} />
              </Table.Td>
              <Table.Td>
                <Skeleton height={14} width={144} />
              </Table.Td>
              <Table.Td>
                <Skeleton height={36} width={144} />
              </Table.Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </div>
);

export default Dashboard;
